import { ItemQuantityCard } from 'components/verify-item';
import { TripContext } from 'contexts';
import React, { Fragment, useContext } from 'react';
import { OrderItem } from 'services/types';
import './TestPage.scss';

const itemId = 524387

export const TestPage = () => {

    const tripContext = useContext(TripContext)

    const item: OrderItem = tripContext.orderItems.find(item => item.id === itemId) ?? {} as OrderItem

    // const items: OrderItem[] = tripContext.orderItems.filter(item => item.countedQuantity > 0)

    // const itemById: OrderItem = tripContext.orderItems.get(itemId) ?? {} as OrderItem
    

    const handleItemQuantityChanged = (po: string | null, quantity: number) => {
        tripContext.orderItems.put({ ...item, countedQuantity: quantity})
        
        // tripContext.orderItems.bulkPut([])
        
        // tripContext.orderItems.remove(item.id)
        
        // tripContext.orderItems.bulkRemove([])
    }

    return (
        <Fragment>
            {tripContext.isReady() ?
                <ItemQuantityCard
                    key={item.customerPoNumber}
                    itemId={item.id}
                    onQuantityAdjusted={handleItemQuantityChanged}
                    onClick={(title) => {}}
                />
            :
                <div>Loading...</div>
            }
        </Fragment>
    )
};
